<template>
    <v-app class="pa-0">
        <v-main class="pa-4" style="background-color:#f4f4f4;">
            <v-container class="pa-4" fluid style="border:solid 1px #111111; min-height:calc(100vh - 32px);">
                    <transition name="fade" mode="out-in">
                        <router-view/>
                    </transition>
            </v-container>
        </v-main>
        <div class="menu-bottom px-4 py-0">
            <v-row class="ma-0">
                <v-col cols="4">
                    <v-list-item to="/">
                        <v-spacer/>
                            <v-icon>mdi-view-dashboard</v-icon>
                        <v-spacer/>
                    </v-list-item>
                </v-col>
                <v-col cols="4">
                    <v-list-item to="/reports">
                        <v-spacer/>
                        <v-icon>mdi-chart-bar</v-icon>
                        <v-spacer/>
                    </v-list-item>
                </v-col>
                <v-col cols="4">
                    <v-list-item to="/events">
                        <v-spacer/>
                        <v-icon>mdi-calendar</v-icon>
                        <v-spacer/>
                    </v-list-item>
                </v-col>
            </v-row>
        </div>
    </v-app>
</template>

<script>
export default {
    data(){
        return{

        }
    },
    created(){
        this.$store.dispatch('currentUser/getUser')
    },
}
</script>

<style>
.menu-bottom{
    position: fixed!important;
    bottom: 0!important;
    width: calc(100vw - 32px)!important;
    left:16px;
    background: #f4f4f4;
    border-top:solid 1px #111111;
}
.v-list-item.v-list-item--link.theme--light:hover i::before{
    color: #f4a17b!important;
}
.v-list-item--active i::before{
    color: #f4a17b!important;
}
.theme--light.v-list-item--active:hover::before, .theme--light.v-list-item--active::before{
    opacity: 0!important;
}
.fade-enter{
    transform: translateX(100vw);
}
.fade-leave-to {
    transform: translateX(-100vw);
}
.fade-enter-active, .fade-leave-active {
    transition: all .15s ease;
}
</style>